<template>
  <div id="">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Nhập kho', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block :nobody="true" ref="buser" class="soft-control">
        <StreamBarcodeReader
          @decode="onDecode"
          @loaded="onLoaded"
        ></StreamBarcodeReader>
      </block>
    </div>
  </div>
</template>
<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
  name: "warehouse-scanner",
  components: {
    StreamBarcodeReader
  },
  data() {
    return {};
  },
  methods: {
    onDecode(e) {
      console.log(e);
    },
    onLoaded(e) {
      console.log(e);
    }
  }
};
</script>
<style lang="scss"></style>
